import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Nav.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToHero = () => {
    setIsOpen(false);

    // If we're not on the home page, navigate there first
    if (location.pathname !== "/") {
      navigate("/");
      // Wait a bit for the navigation to complete, then scroll
      setTimeout(() => {
        const heroSection = document.querySelector(".homepage-container");
        if (heroSection) {
          heroSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // If we're already on the home page, just scroll
      const heroSection = document.querySelector(".homepage-container");
      if (heroSection) {
        heroSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img
            src="/Assets/protek logo.png"
            alt="Logo"
            className="logo-img"
            loading="lazy"
          />
        </Link>

        <button
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <div className={`navbar-links ${isOpen ? "open" : ""}`}>
          <button onClick={scrollToHero} className="nav-link-btn">
            HOME
          </button>
          <Link
            to="/about"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            ABOUT
          </Link>
          <Link
            to="/services"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            SERVICES
          </Link>
          <Link
            to="/gallery"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            PROJECTS
          </Link>
          <Link
            to="/blogs"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            BLOGS
          </Link>
          <Link
            to="/contact"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            CONTACT US
          </Link>
        </div>
      </div>
    </nav>
  );
}
